export interface DeskInvokeResult {
  statusCode: number;
  response: string;
  responseHeaders: Record<string, string>;
}

export interface DeskInvokeClientDeps {
  isBaseUrl: string;
  jwt: string;
  fetch?: typeof globalThis.fetch;
}

export class DeskInvokeClient {
  constructor(private readonly deps: DeskInvokeClientDeps) {}

  private async post(payload: Record<string, string>): Promise<DeskInvokeResult> {
    const fetcher = this.deps.fetch ?? globalThis.fetch;
    const res = await fetcher(`${this.deps.isBaseUrl}/v1/zoho/desk-api`, {
      method: 'POST',
      headers: {
        authorization: `Bearer ${this.deps.jwt}`,
        'content-type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    if (!res.ok) {
      const detail = await res.text().catch(() => '');
      throw new Error(`Desk Invoke proxy failed: ${res.status}${detail ? ` — ${detail}` : ''}`);
    }
    return (await res.json()) as DeskInvokeResult;
  }

  async searchContactByPhone(input: { orgId: string; phoneE164: string; deskApiBaseUrl: string }): Promise<DeskInvokeResult> {
    return this.post({
      requestURL: `${input.deskApiBaseUrl}/api/v1/contacts/search?phone=${encodeURIComponent(input.phoneE164)}`,
      requestType: 'GET',
      orgId: input.orgId,
    });
  }

  async findOpenTicketByContact(input: { orgId: string; contactId: string; deskApiBaseUrl: string }): Promise<DeskInvokeResult> {
    return this.post({
      requestURL: `${input.deskApiBaseUrl}/api/v1/tickets/search?contactId=${encodeURIComponent(input.contactId)}&status=Open`,
      requestType: 'GET',
      orgId: input.orgId,
    });
  }
}
